import React, { useEffect, useState } from 'react'
import { Loader } from '@components/ui-css/Loader/Loader'
import styles from './styles/FallbackIndicator.module.scss'

export const FallbackIndicator: React.FC = () => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    setTimeout(() => setShow(true), 500)

    return () => setShow(false)
  }, [])

  return (
    <>
      {show && (
        <div className={styles.container}>
          <Loader variant="dark" size="large" />
        </div>
      )}
    </>
  )
}
